export default __webpack_public_path__ + "static/media/lora.5084ee01.jpg";